const defaultFields=[
  {id:'name',label:'Name',type:'Short text',required:false,options:[]},
  {id:'introduction',label:'Introduction',type:'Long text',required:false,options:[]},
  {id:'music',label:'Music',type:'Song entry',required:false,options:[]},
  {id:'notes',label:'Notes',type:'Long text',required:false,options:[]}
];

const fieldPresets={
  candle:{
    fields:[
      {id:'name',label:'Name',type:'Short text',required:false,options:[]},
      {id:'introduction',label:'How to Introduce',type:'Long text',required:false,options:[]},
      {id:'music',label:'Music',type:'Song entry',required:false,options:[]}
    ]
  },
  parent:{
    fields:[
      {id:'person',label:'Person',type:'Short text',required:false,options:[]},
      {id:'dance',label:'Dance',type:'Short text',required:false,options:[]},
      {id:'song',label:'Song',type:'Song entry',required:false,options:[]},
      {id:'notes',label:'Notes',type:'Long text',required:false,options:[]}
    ]
  },
  introduction:{
    fields:[
      {id:'name',label:'Name',type:'Short text',required:false,options:[]},
      {id:'introduction',label:'How to Introduce',type:'Long text',required:false,options:[]},
      {id:'music',label:'Music',type:'Song entry',required:false,options:[]}
    ]
  }
};

function clone(value){
  return JSON.parse(JSON.stringify(value));
}

export function getDefaultRepeatingFields(question={}){
  const id=String(question.id||'').toLowerCase();
  const title=String(question.title||'').toLowerCase();

  if(id.includes('candle')||title.includes('candle')){
    return clone(fieldPresets.candle.fields);
  }

  if(id.includes('parent')||title.includes('parent dance')){
    return clone(fieldPresets.parent.fields);
  }

  if(id.includes('introduction')||title.includes('introduction')){
    return clone(fieldPresets.introduction.fields);
  }

  return clone(defaultFields);
}

export function getRepeatingFields(question={}){
  return Array.isArray(question.fields)&&question.fields.length>0
    ? clone(question.fields)
    : getDefaultRepeatingFields(question);
}

export function createRepeatingField(){
  return {
    id:`field-${Date.now()}-${Math.random().toString(36).slice(2,7)}`,
    label:'New field',
    type:'Short text',
    required:false,
    options:[]
  };
}